// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import TimegridOverrideTemplate from './data'

export default function TimegridOverrideTemplateFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/TimegridOverrideTemplate">
      <TimegridOverrideTemplate {...props}>
        {children}
      </TimegridOverrideTemplate>
    </Flow>
  )
}
